import { connect } from 'react-redux'
import * as action from '../../state/barcode/action'
import * as selector from '../../state/barcode/selector'
import Barcode from './Barcode'

const mapStateToProps = (state, props) => {
    return {
        barcode: selector.selectBarCode(state),
    }
}

const mapDispatchToProps = {
    changeBarCode: action.changeBarCode,
    onBarCodeEnter: action.onBarCodeEnter,
}

export default connect(mapStateToProps, mapDispatchToProps)(Barcode)



// WEBPACK FOOTER //
// ./src/modules/process/component/barcode/BarcodeContainer.js